import { render } from "./FlowNodeWrapper.vue?vue&type=template&id=72247462&scoped=true&ts=true"
import script from "./FlowNodeWrapper.vue?vue&type=script&lang=ts"
export * from "./FlowNodeWrapper.vue?vue&type=script&lang=ts"

import "./FlowNodeWrapper.vue?vue&type=style&index=0&id=72247462&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72247462"]])

export default __exports__